export const isAbortLikeError = (error) =>
  error?.name === "AbortError" ||
  error?.message?.includes("aborted") ||
  error?.message?.includes("signal is aborted");

export const isTransientNetworkError = (error) => {
  const message = error?.message?.toLowerCase?.() || "";
  const code = error?.code?.toLowerCase?.() || "";
  const status = Number(error?.status);

  return (
    isAbortLikeError(error) ||
    error?.name === "TimeoutError" ||
    message.includes("timed out") ||
    message.includes("timeout") ||
    message.includes("failed to fetch") ||
    message.includes("network") ||
    code === "err_timed_out" ||
    status === 408 ||
    status === 429 ||
    status === 502 ||
    status === 503 ||
    status === 504
  );
};
